// @ts-strict-ignore
import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import { JoinEntryCardProps } from './types';
import {
  Stack,
  HeaderText,
  BodyText,
  Button,
} from '../../../ui';

export const JoinEntryCard = ({
  description,
  title,
  breakpoints,
  screenWidth,
  onClick,
}: JoinEntryCardProps) => {
  let width = 268;
  if ((breakpoints?.tablet || breakpoints?.desktopNarrow) && screenWidth > 430) {
    width = 200;
  }
  return (
    <Stack
      testID={`join-entry-card-${title}`}
      color={BrandColor.WhiteWash}
      width={width}
      height="100%"
      borderRadius={8}
      justifyContent="stretch"
      alignItems="flex-start"
      padding={16}
      space={8}
    >
      <HeaderText level={4} textAlign="left">{title}</HeaderText>

      <Box>
        <BodyText textAlign="left" appearance="normal" color={BrandColor.Metal}>{description}</BodyText>
      </Box>

      <Button
        appearance="primary-fresh"
        size="small"
        onClick={onClick}
        style={{
          paddingTop: 4,
          paddingBottom: 4,
          marginTop: 'auto',
        }}
      >
        Learn More
      </Button>
    </Stack>
  );
};
